import { render, staticRenderFns } from "./AgendaDay.vue?vue&type=template&id=6459ed95&scoped=true"
import script from "./AgendaDay.vue?vue&type=script&lang=js"
export * from "./AgendaDay.vue?vue&type=script&lang=js"
import style0 from "./AgendaDay.vue?vue&type=style&index=0&id=6459ed95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6459ed95",
  null
  
)

export default component.exports